import { BreadcrumbItem } from '@zeus/core/layout/MainLayout';
import { useCollection } from '_/contexts/CollectionContext';
import { useTopHeader } from '_/contexts/LayoutContext';
import { useOrganization } from '_/contexts/OrganizationContext';
import { useProject } from '_/contexts/ProjectContext';
import { useSourceContext } from '_/contexts/SourceContext';
import ExtractorVersionHistory from '_/features/extractors/versions/ExtractorVersionHistory';
import React, { useEffect, ReactElement } from 'react';

function SourceExtractorHistory(): ReactElement {
  const { selectedSource: source, selectedSourceSlug } = useSourceContext();
  const { selectedOrgSlug, selectedOrganization } = useOrganization();
  const { selectedProjectSlug, selectedProject } = useProject();
  const { selectedCollectionSlug, selectedCollection } = useCollection();
  const { setBreadcrumbs } = useTopHeader();

  // Set up breadcrumbs
  useEffect(() => {
    const breadcrumbs: BreadcrumbItem[] = [
      { title: 'Organizations', href: '/orgs' },
      { title: selectedOrganization?.name || '', href: `/orgs/${selectedOrgSlug}` },
      { title: 'Projects', href: `/orgs/${selectedOrgSlug}/projects` },
      {
        title: selectedProject?.name || '',
        href: `/orgs/${selectedOrgSlug}/projects/${selectedProjectSlug}/home`,
      },
      {
        title: 'Collections',
        href: `/orgs/${selectedOrgSlug}/projects/${selectedProjectSlug}/collections`,
      },
    ];

    if (selectedCollection) {
      breadcrumbs.push({
        title: selectedCollection.name || '',
        href: `/orgs/${selectedOrgSlug}/projects/${selectedProjectSlug}/collections/${selectedCollectionSlug}/home`,
      });
    }

    if (source) {
      breadcrumbs.push(
        {
          title: 'Sources',
          href: `/orgs/${selectedOrgSlug}/projects/${selectedProjectSlug}/collections/${selectedCollectionSlug}/sources`,
        },
        {
          title: source.name || '',
          href: `/orgs/${selectedOrgSlug}/projects/${selectedProjectSlug}/collections/${selectedCollectionSlug}/sources/${selectedSourceSlug}/home`,
        },
        { title: 'Extractor Versions' },
      );
    }

    setBreadcrumbs(breadcrumbs);

    return () => {
      setBreadcrumbs([]);
    };
  }, [
    setBreadcrumbs,
    selectedOrganization,
    selectedOrgSlug,
    selectedProject,
    selectedProjectSlug,
    selectedCollection,
    selectedCollectionSlug,
    source,
    selectedSourceSlug,
  ]);

  return <ExtractorVersionHistory extractorId={source?.extractorId} />;
}

export default SourceExtractorHistory;
